<template>
  <div class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <button
        class="button is-dark"
        v-on:click='sendEmails()'
    >
          Enviar informes a líderes
          <span class="icon" style='margin-left: 5px'>
            <i class="material-icons">send</i>
          </span>
    </button>
  </div>
</template>
<script>
import apiServices from '@/services/yungol-services'
import {mapState} from 'vuex'

export default {
  data(){
    return {

    }
  },
  props:{
    proceso: Object
  },
  computed:{
    ...mapState(['isMovil']),
  },
  methods:{
    async sendEmails(){
      const config = {
        title: '¿Estás seguro?',
        text: "Enviarás los correos con los resultados a todos los líderes.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, enviar'
      };
      const self = this
      await this.$swal(config).then(async function(result) {
        if (result.isConfirmed) {
          try {
            const resultD = await apiServices.get(
                '/crearusuariolideres/' + self.proceso._id
            );
            if (resultD.data.success) {
              const count = resultD.data.enviados ? resultD.data.enviados.length : 0
              await self.$swal({
                text: 'Correos enviados correctamente a ' + count + ' líder(es).',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
              })
            } else {
              await self.$swal({
                text: resultD.data.message || 'No se pudieron enviar los correos.',
                icon: 'warning',
                showConfirmButton: false,
                timer: 1700
              })
            }
          } catch (error) {
            await self.$swal({
              text: 'Error al enviar los correos.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lideres/components/menuTableSummary.vue